import { createHash } from "crypto"

import * as Sentry from "@sentry/browser"
import { CaptureContext } from "@sentry/types"

import { isBrowser } from "../../../utils/infrastructure/ssg-utils"

declare global {
    interface Window {
        Sentry: typeof Sentry
    }
}

export class SentryWrapper {
    private static instance: SentryWrapper
    sentryApi: typeof Sentry

    private constructor() {
        let api = Sentry
        if (isBrowser() && window.Sentry) {
            api = window.Sentry
        }
        this.sentryApi = api
        return SentryWrapper.instance
    }

    public static getInstance(): SentryWrapper {
        if (!SentryWrapper.instance) {
            SentryWrapper.instance = new SentryWrapper()
        }

        return SentryWrapper.instance
    }

    init(options: Sentry.BrowserOptions) {
        if (!window.Sentry) {
            options.dsn = undefined
        }
        this.sentryApi.init(options)
    }

    captureMessage(message: string, captureContext?: CaptureContext) {
        this.sentryApi.captureMessage(message, captureContext)
    }

    captureException(exception: unknown, captureContext?: CaptureContext | undefined) {
        this.sentryApi.captureException(exception, captureContext)
    }

    saveUserToScope(who: "psy" | "client", email?: string) {
        const hashed = email ? createHash("sha1").update(email).digest("hex") : "unknown email"
        this.sentryApi.configureScope((scope) => {
            scope.setUser({
                email: `${who}: ${hashed}`,
            })
        })
        return () =>
            this.sentryApi.configureScope((scope) => {
                scope.setUser(null)
            })
    }

    addBreadcrumb(message: string) {
        this.sentryApi.addBreadcrumb({ message, level: "info" })
    }
}
